module.exports = __webpack_public_path__ + "img/eye.a0fdbcb5.svg";